module.exports = __webpack_public_path__ + "img/bc-logo-188.8abb83fb.png";